"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    FileHeart: function() {
        return FileHeart;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const FileHeart = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsx)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M3 4C3 2.34315 4.34315 1 6 1H14C14.2652 1 14.5196 1.10536 14.7071 1.29289L20.7071 7.29289C20.8946 7.48043 21 7.73478 21 8V20C21 21.6569 19.6569 23 18 23H6C4.34315 23 3 21.6569 3 20V4ZM6 3C5.44772 3 5 3.44772 5 4V20C5 20.5523 5.44772 21 6 21H18C18.5523 21 19 20.5523 19 20V9H14C13.4477 9 13 8.55228 13 8V3H6ZM15 4.41421L17.5858 7H15V4.41421ZM11.997 11.933C10.9974 11.3394 9.68367 11.2979 8.62297 12.161C7.32953 13.2135 7.11986 15.0349 8.16768 16.319C8.36973 16.5666 8.667 16.7959 8.91345 16.9747C9.15689 17.1512 9.44121 17.3413 9.71614 17.525C9.74315 17.5431 9.77008 17.5611 9.79687 17.579C10.4434 18.0115 10.9876 18.3878 11.2715 18.6876C11.4605 18.8871 11.7232 19.0001 11.9981 19C12.2729 18.9999 12.5356 18.8866 12.7243 18.6869C13.0072 18.3876 13.5509 18.0116 14.1978 17.579C14.2251 17.5608 14.2525 17.5424 14.2801 17.524C14.5546 17.3406 14.8384 17.1509 15.0814 16.9747C15.3279 16.7961 15.6254 16.5667 15.8275 16.319C16.8659 15.0465 16.6948 13.2078 15.3617 12.1526C14.2966 11.3095 12.9947 11.3402 11.997 11.933ZM11.2536 13.8801C10.8531 13.4342 10.2851 13.387 9.88531 13.7123C9.42522 14.0867 9.38802 14.6511 9.71726 15.0546C9.71515 15.052 9.72103 15.0594 9.73941 15.0773C9.75725 15.0947 9.78231 15.1176 9.81611 15.1462C9.88465 15.2042 9.97466 15.2737 10.0877 15.3557C10.2983 15.5084 10.5502 15.6769 10.8341 15.8667C10.8588 15.8832 10.8837 15.8998 10.9088 15.9166L10.9166 15.9218C11.248 16.1435 11.637 16.4037 11.9973 16.6786C12.3579 16.4034 12.7474 16.1429 13.079 15.9212L13.086 15.9165C13.1118 15.8992 13.1374 15.8821 13.1627 15.8652C13.446 15.6759 13.6973 15.5079 13.9076 15.3555C14.0206 15.2735 14.1107 15.204 14.1792 15.146C14.213 15.1174 14.2381 15.0946 14.2559 15.0772C14.2719 15.0616 14.2784 15.054 14.2784 15.0541C14.2784 15.0541 14.2782 15.0542 14.2779 15.0546C14.6166 14.6395 14.571 14.0774 14.1204 13.7208C13.695 13.384 13.1348 13.4423 12.7416 13.8801C12.5519 14.0913 12.2814 14.2119 11.9976 14.2119C11.7138 14.2119 11.4433 14.0913 11.2536 13.8801Z",
        fill: "currentColor"
    })
}), "FileHeart");
const _default = FileHeart;
